module.exports = __webpack_public_path__ + "static/media/5.b7b3904f.jpg";